// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Authentication__container___DILb5{margin-top:64px;text-align:center;width:100%}.Authentication__container___DILb5 .Authentication__spaceUp___20ZXl{margin-top:32px}", "",{"version":3,"sources":["webpack://src/component/Authentication/Authentication.scss"],"names":[],"mappings":"AAAA,mCAAW,eAAe,CAAC,iBAAiB,CAAC,UAAU,CAAC,oEAAoB,eAAe","sourcesContent":[".container{margin-top:64px;text-align:center;width:100%}.container .spaceUp{margin-top:32px}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "Authentication__container___DILb5",
	"spaceUp": "Authentication__spaceUp___20ZXl"
};
export default ___CSS_LOADER_EXPORT___;
